import { FC, PropsWithChildren, createContext, useCallback, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

import { getTemplates } from 'services/templates';
import { Template } from 'types';

import { useTemplateApi } from 'hooks/use-template-api';

type TemplatesContextType = {
  templates: Template[];
  addTemplate: (template: Template) => void;
};

const TemplatesContext = createContext<TemplatesContextType>({} as TemplatesContextType);

export const useTemplates = () => useContext(TemplatesContext);

export const TemplatesProvider: FC<PropsWithChildren> = ({ children }) => {
  const navigate = useNavigate();

  const { postTemplate } = useTemplateApi();

  const [templates, setTemplates] = useState<Template[]>([]);

  const loadTemplates = useCallback(async () => {
    setTemplates(await getTemplates({}));
  }, [setTemplates]);

  useEffect(() => {
    loadTemplates();
  }, [loadTemplates]);

  const addTemplate = useCallback(
    async (template: Template) => {
      const response = await postTemplate(template);
      if (response) {
        await loadTemplates();
        navigate('/templates');
      }
    },
    [loadTemplates, navigate, postTemplate]
  );

  return <TemplatesContext.Provider value={{ templates, addTemplate }}>{children}</TemplatesContext.Provider>;
};
